import { render } from "./EditTimeSheet.vue?vue&type=template&id=1522fe71&scoped=true"
import script from "./EditTimeSheet.vue?vue&type=script&lang=js"
export * from "./EditTimeSheet.vue?vue&type=script&lang=js"

import "./EditTimeSheet.vue?vue&type=style&index=0&id=1522fe71&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1522fe71"]])

export default __exports__